export const PUBLIC_SERVER_URL="https://hostelease-rbds.onrender.com"
// export const PUBLIC_SERVER_URL="http://localhost:5000"